import { createAxiosClient } from "@ntg/component-library/utilities";

export interface IRouteVersionByItem {
    csRouteID: number;
    dataAreaID: string;
    routeId: string;
    productionSiteId: string;
    itemNumber: string;
    productSizeId: string;
    productColorId: string;
    productConfigurationId: string;
    productStyleId: string;
    productVersionId: string;
}

export const getRouteVersionByItem = async (
    itemNumber: string,
    dataAreaId: string,
): Promise<IRouteVersionByItem | null> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<IRouteVersionByItem | null>(
        `/RouteVersion/GetRouteVersionByItemCS`,
        { params: { itemNumber, dataAreaId } },
    );
    // 204 returns an empty body — axios resolves response.data to "" or undefined
    // depending on parser. Coerce to null so downstream code that compares `=== null`
    // works correctly (the explorer's CS-vs-D365 dispatch relies on this).
    return (response.status === 204 || !response.data) ? null : response.data;
};
